module.exports = __webpack_public_path__ + "img/soft-bg-2.7ed41e44.png";